<template>
  <ForceNewsBlockWrapper :requireCharacters="requireCharacters"
                         :titleLabel="isCorporation ? $t('profile.label.my_number.corporation') : $t('profile.label.my_number.individual')"
                         :parentScreen="parentScreen">
    <div class="form-group row">
      <template v-if="isCorporation">
        <label class="control-label col-md-3 col-form-label" v-html="$t('profile.label.my_number_personal.corporation')"/>
      </template>
      <template v-else>
        <label class="control-label col-md-3 col-form-label" v-html="$t('profile.label.my_number_personal.individual')"/>
      </template>
      <div class="col-md-6">
        <FileInput v-model="$v.fileMnUpload1.$model" name="fileMnUpload1"
                   @onChangeFileInput="handleChangeFileInput">
        </FileInput>
        <error-messages-block :field="$v.fileMnUpload1">
          <template #fileTypeValidation>
            {{ $t('profile.error.file_type', {param1: fileTypeExtension}) }}
          </template>
          <template #fileSizeValidation>
            {{ $t('profile.error.file_size') }}
          </template>
        </error-messages-block>
      </div>
    </div>
    <div class="form-group row">
      <div class="col-md-6 offset-md-3">
        <FileInput v-model="$v.fileMnUpload2.$model" name="fileMnUpload2"
                   @onChangeFileInput="handleChangeFileInput">
        </FileInput>
        <error-messages-block :field="$v.fileMnUpload2">
          <template #fileTypeValidation>
            {{ $t('profile.error.file_type', {param1: fileTypeExtension}) }}
          </template>
          <template #fileSizeValidation>
            {{ $t('profile.error.file_size') }}
          </template>
        </error-messages-block>
      </div>
    </div>
    <div class="clearfix news-form-clearfix"></div>
    <div class="form-group row">
      <div :class="this.isParentScreenForceNew? 'col-md-9': 'col-md-12' ">
        <div class="alert alert-warning">
          <template v-if="isCorporation">
            <div v-html="$t('profile.label.upload.mynumber.new.corporation')"></div>
          </template>
          <template v-else>
            <div v-html="$t('profile.label.upload.mynumber.new.individual')"></div>
          </template>
        </div>
      </div>
    </div>
    <template v-if="this.isParentScreenEditProfile">
      <div class="form-action">
        <button class="btn btn-sm btn-submit btn-success mr-2"
                :disabled="isDisabledButtonSubmit && isInvalidFile"
                @click="uploadMynumber"
                type="button"
        >
          {{ $t('profile.button.mn') }}
        </button>
        <button class="btn btn-default btn-cancel btn-sm"
                type="button"
                @click="reverseInput">
          {{ $t('profile.button.cancel') }}
        </button>
      </div>
    </template>
  </ForceNewsBlockWrapper>
</template>
<script>
/**
 * @author HungNS
 */
import formMixin from '@/common/mixins/form';
import forceNewUtil from "@/common/mixins/forceNewUtil";
import preparedDataInput from '@/common/mixins/preparedDataInput'
import $ from 'jquery';
import {isNil} from 'lodash'
import {createNamespacedHelpers} from "vuex";

const {mapGetters: mapForceNewsGetters} = createNamespacedHelpers("forceNews");

export default {
  name: "UpdateMyNumber",
  props: {
    blockInfo: {
      type: String
    }
  },
  data() {
    return {
      fileMnUpload1: null,
      fileMnUpload2: null,
    }
  },
  mixins: [formMixin, preparedDataInput, forceNewUtil],
  validations() {
    const initValidData = this.getInitFileValidation({...this.$data}, [], undefined, false);
    return {
      ...initValidData
    }
  },
  computed: {
    fileUploadExt() {
      return this.$store.state.header.headerInfo.fileUploadExt
    },
    fileTypeExtension() {
      return this.fileUploadExt.toUpperCase();
    },
    isInvalidFile(){
      const {$v} = this;
      return $v.$anyError || (this.fileMnUpload1 === null && this.fileMnUpload2 === null);
    },
    isCorporation() {
      return this.$store.state[this.namespace].isCorporation
    },
    ...mapForceNewsGetters(['mapGroupFieldAmsCustomer']),
  },
  methods: {
    async uploadMynumber() {
      $("html, body").animate({scrollTop: 0}, "slow");

      const file1 = $("input[id='fileMnUpload1']").val();
      const file2 = $("input[id='fileMnUpload2']").val();

      if ((isNil(file1) || (file1 == '')) && (isNil(file2) || (file2 == ''))) {
        this.$emit('myNumberUploadInputEmpty');
        return;
      }

      this.changeBlockInfo = this.blockInfo
      let self = this;

      await this.$service.getService('profile').uploadMyNumber(this.preparedDataInput(self))
          .then(response => {
            if (response.data.successMessage === 'profile.label.upload.mynumber.msg.success') {
              self.$parent.$emit('onMessage',
                  self.$t('profile.label.upload.mynumber.msg.success'),
                  self.IConstants.API_MESSAGE_TYPE.SUCCESS);
            }
            if (response.data.errorMessage === 'profile.label.upload.mynumber.msg.fail') {
              self.$parent.$emit('onMessage',
                  self.$t('profile.label.upload.mynumber.msg.fail'),
                  self.IConstants.API_MESSAGE_TYPE.ERROR);
            }
          }).catch(() => {
            self.$parent.$emit('onMessage', 'error.happen', this.IConstants.API_MESSAGE_TYPE.ERROR);
          }).finally(() => {
            self.reverseInput();
          })
    },
  }
}
</script>

<style scoped>

</style>
